import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Projects() {
  return (
    <>
      <Header />
      
      <section className="projects-section container">
        <h1 className="projects-title"><span className="projects-title-line-1">FEATURED</span><br/><span className="projects-title-line-2">PROJECTS</span></h1>
        <div className="projects-grid">

          <div className="project-card">
            <a href="/projects/solo-beauty">
              <img src="/assets/WhatsApp Image 2026-02-17 at 8.31.55 PM.jpeg" alt="Solo Beauty Project" />
            </a>
            <div className="project-title">Solo Beauty</div>
            <p className="project-desc">Solo Beauty is a beauty and skincare brand offering personalized cosmetic products and digital solutions, helping users discover, explore, and purchase tailored beauty essentials seamlessly.</p>
            <a href="/projects/solo-beauty" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>

          <div className="project-card">
            <a href="/projects/flash-delivery">
              <img src="/assets/flash-delivery-cover.jpeg" alt="Flash Delivery Project" />
            </a>
            <div className="project-title">Flash Delivery</div>
            <p className="project-desc">Flash Delivery is a quick-commerce platform that enables ultra-fast delivery of groceries and daily essentials, ensuring convenience, speed, and seamless last-mile fulfillment for customers.</p>
            <a href="/projects/flash-delivery" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>

          <div className="project-card">
            <a href="/projects/liveeasy">
              <img src="/assets/Screenshot 2026-02-17 213827.png" alt="LIVEASY Project" />
            </a>
            <div className="project-title">Liveasy</div>
            <p className="project-desc">LIVEASY is a technology-driven logistics company connecting shippers and truckers, streamlining freight operations, optimizing routes, and improving supply chain efficiency through digital solutions.</p>
            <a href="/projects/liveeasy" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>

          <div className="project-card">
            <a href="/projects/personal-work">
              <img src="/assets/WhatsApp Image 2026-02-18 at 5.12.42 PM.jpeg" alt="Personal Project" />
            </a>
            <div className="project-title">This is what I do in my free time</div>
            <p className="project-desc">A creative exploration of personal interests and experimental design work, showcasing passion projects and innovative concepts developed outside client work.</p>
            <a href="/projects/personal-work" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}

export default Projects;
